// BASIC STARTER REQUIREMENTS
var lazy = require('./vendor/jquery.lazy.js');
require('./vendor/skip-link-focus-fix.js');
require('babel-polyfill');

// ADDITIONAL 3RD PARTY REQUIREMENTS
var slick 			= require('./vendor/slick.js');
// var _ 				= require('underscore');
// var moment 			= require('moment');
// var foundation 		= require('foundation-sites'); // Requires: npm install foundation-sites

// Get Viewport Dimensions
function updateViewportDimensions() {
    var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
    return { width:x,height:y };
}

function isInternetExplorer () {
    return !!( navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/) );
}

// setting the viewport width
var viewport = updateViewportDimensions();

// David Walsh Debounce
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    }
}

// Throttle from underscore 1.8.3
function throttle (func, wait, options) {
    var context, args, result
    var timeout = null
    var previous = 0
    if (!options) options = {}
    var later = function () {
        previous = options.leading === false ? 0 : Date.now()
        timeout = null
        result = func.apply(context, args)
        if (!timeout) context = args = null
    }
    return function () {
        var now = Date.now()
        if (!previous && options.leading === false) previous = now
        var remaining = wait - (now - previous)
        context = this
        args = arguments
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            previous = now
            result = func.apply(context, args)
            if (!timeout) context = args = null
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining)
        }
        return result
    }
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

jQuery.fn.slideFadeToggle  = function(speed, easing, callback) {
    return this.animate({opacity: 'toggle', height: 'toggle'}, speed, easing, callback);
}; 

// Braid Namespace
var braid = braid || {};
braid.prevArrowUrl = '/wp-content/themes/pebbletossers/lib/img/gray-arrow-left.svg';
braid.nextArrowUrl = '/wp-content/themes/pebbletossers/lib/img/gray-arrow-right.svg';
braid.prevArrow = `<div class="grayArrow__container grayArrow__container--prev"><img class="grayArrow" src="${braid.prevArrowUrl}" /></div>`;
braid.nextArrow = `<div class="grayArrow__container grayArrow__container--next"><img class="grayArrow" src="${braid.nextArrowUrl}" /></div>`;

// utilities
braid.query = function(selector) {
    return document.querySelector(selector);
};

braid.isHome = !!document.getElementsByClassName('home').length;
braid.isFlexible = !!document.getElementsByClassName('page-template-page-flexible').length;
braid.hasForm = !!document.getElementsByClassName('gform_wrapper').length;
braid.header = document.getElementById("masthead");
braid.content = document.getElementById("content");
braid.menu = document.getElementById("site-navigation");
braid.page = document.getElementById("page");
braid.mobileBreakpoint = 680;



// Set up namespace
var braidStarter = braidStarter || {};

(function(ns, $win, $, undefined) {
    var $body = $('body');
    var $htmlBody = $('html, body');

    // http://jquery.eisbehr.de/lazy/
    // usage <img class="lazy" data-src="/some-path" alt=""> for img
    // usage <div class="lazy" data-src="/some-path" alt=""> for background image
    function initLazyLoad() {
        $('.lazy').lazy({
            effect: "fadeIn",
            effectTime: 500,
            threshold: 500
        });
    }

    function addIeClassToBody () {
        if( isInternetExplorer() ) {
            $('body').addClass('internet-explorer');
        }
    }

    function toggleNavMenu() {
        var $header = $(braid.header);
        var $menuBackground = $('#site-menu-background');
        var $hamburger = $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4');

        $hamburger.click(function() {
            $(this).toggleClass('open');
            $header.toggleClass('active');
            $body.toggleClass('frozen');
        });

        $menuBackground.click(function() {
            $header.removeClass('active');
        });
    }

    function smoothScroll() {
        var $links = $('.smooth-scroll');

        $links.click(function(e){
            e.preventDefault();
            var $this = $(this);
            var $target = $($this.attr('href'));
            $htmlBody.animate({scrollTop: $target.offset().top}, '500', 'swing');
        });
    }

    function contentAccordion() {
        $('.content-accordion').on('click', '.content-accordion--btn', function() {
            var $btn = $(this);
            var $container = $btn.closest('.content-accordion');
            var $content = $container.find('.content-accordion--hidden');
            $content.slideToggle(function(){
                $content.is(':visible') ? $btn.text('See Less') : $btn.text('See More');;
            });
        });
    }

    function handleHeaderScroll() {
        var threshold = 0.05 * $(document).height();
        function setHeaderScroll() {
            var distanceFromTop = -braid.content.getBoundingClientRect().top;
            if (distanceFromTop < threshold) {
                braid.header.classList.add("top");
            } else {
                braid.header.classList.remove("top");
            }
        }

        setHeaderScroll();
        window.onscroll = throttle(setHeaderScroll, 100);
    }

    function initCauseCardSlider() {
        var $cards = $('.js-cause-cards');

        $cards.slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 6,
            prevArrow: braid.prevArrow,
            nextArrow: braid.nextArrow,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    function isScrolledIntoView($elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();


        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();
        var elemCenter = elemTop + 0.5 * $elem.height();

        return ((elemCenter <= docViewBottom) && (elemCenter >= docViewTop));
    }

    function handleRipples() {
        var $ripples = $('.js-ripple');

        function handleRipple($ripple) {
            if( isScrolledIntoView($ripple) ) {
                $ripple.addClass('active');
            }
        }

        $.each($ripples, function() {
            var $ripple = $(this);
            handleRipple($ripple);
            $(document).scroll(throttle(
                handleRipple.bind(null, $ripple),
                100
            ));
        });
    }

    function handleStories() {
        var $storyBlocks = $('.js-stories');
        $.each($storyBlocks, function() {
            var $this = $(this);

            var $items = $this.find('.js-items');
            $items.slick({
                arrows: false,
                touchMove: false,
                draggable: false,
                swipe: false,
                swipeToSlide: false,
                touchMove: false,
                draggable: false,
                fade: true
            });

            var $select =  $this.find('.js-stories-select');
            $select.change(function() {
                var option = $("option:selected", this);
                var $option = $(option);
                var slideIndex = parseInt($option.data('slide'));
                $items.slick('slickGoTo', slideIndex);
            });
        });
    }

    function handlePartnersSlider() {
        var $partners = $('.js-partners');
        $partners.slick({
            slidesToShow: 6,
            slidesToScroll: 6,
            prevArrow: braid.prevArrow,
            nextArrow: braid.nextArrow,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }

    function handlePartnersBlock() {
        var $partnerItem = $('.js-partner-item');

        function insertClonedHtml($item, clonedSubitemHtml) {
            var itemPosition = $item.offset().top;
            
            $.each($partnerItem, function(index) {
                var $this = $(this);
                var position = $this.offset().top;

                if(position > itemPosition) {
                    $this.before(clonedSubitemHtml);
                    return false;
                }

                if(index === $partnerItem.length - 1) {
                    $this.after(clonedSubitemHtml);
                    return false;
                }
            });
        }

        function togglePartners($el) {
            if(!$el.hasClass('active')) {
                $partnerItem
                    .siblings('.js-subitems')
                    .remove();

                $partnerItem.removeClass('active');
                var $subitem = $el.find('.js-subitems');

                if($subitem.length) {
                    $el.addClass('active');
                    var clonedSubitemHtml = $subitem.prop('outerHTML');
                    insertClonedHtml($el, clonedSubitemHtml);
                }
            }
        }

        $partnerItem.click(function() {
            var $this = $(this);
            togglePartners($this);
        });

        var $featuredItem = $('.js-partner-item-featured');
        if($featuredItem.length) {
            togglePartners($featuredItem);
        }
    }

    function handleCta3Block() {
        var $container = $('.js-cta3-container');
        $.each($container, function() {
            var $this = $(this);
            var $items = $this.find('.js-cta3-items');
            var $button = $this.find('.js-cta3-button');
            
            $items.slick({
                arrows: false,
                touchMove: false,
                draggable: false,
                swipe: false,
                swipeToSlide: false,
                touchMove: false,
                draggable: false,
                responsive: [
                    {
                        breakpoint: 680,
                        settings: {
                            adaptiveHeight: true
                        }
                    }
                ]
            });

            $button.click(function() {
                var $this = $(this);
                $button.removeClass('active');
                $this.addClass('active');
                var slideIndex = parseInt($this.data('slide'));
                $items.slick('slickGoTo', slideIndex);
            });
            
        });
    }

    function handleSocialMediaClick() {
        var $ring = $('.js-iconring');
        $.each($ring, function(index) {
            var $this = $(this);
            $this.click(function() {
                var selector = `.socialMedia__iconsContainer .socialIcons__itemContainer:nth-child(${index + 1}) .socialIcons__itemLink`;
                var href = $(selector).attr('href');
                window.open(href, '_blank');
            });
        });
    }

    function handleFaqs() {
        var $item = $('.js-faq-item');
        $.each($item, function() {
            var $this = $(this);
            var $toggle = $this.find('.js-toggle');
            var $answer = $this.find('.js-answer');
            $toggle.click(function() {
                $this.toggleClass('active');
                $answer.slideToggle();
            });
        });
    }

    function handleMobileCardFlips() {
        var $item = $('.js-card-item-container');
        $item.click(function() {
            $(this).toggleClass('active');
        });
    }

    function handleMenuArrows() {
        var $templateContainer = $('.js-arrow-template');
        var $template = $templateContainer.find('.arrow__container');
        var templateHtml = $template.prop('outerHTML');
        var $donationButton = $('.js-donation a');
        $donationButton.before(templateHtml);
    }

    function handleDonationClick() {
        var $target = $('.js-donation');
        $.each($target, function() {
            var $this = $(this);
            $this.click(function() {
                var $link = $this.children('a');
                var href = $link.attr('href');
                window.open(href, '_blank');
            });
        });
    }

    function prepopulateForms() {
        var fields = [
            'reason'
        ];

        fields.forEach(function(field) {
            var value = getParameterByName(field);
            var $gfield = $(`.gfield.${field}`);

            

            if(value && $gfield.length) {
                
            }
        });
    }

    function handleSmoothScroll() {
        $(document).on('click', 'a[href^="#"]', function (event) {
            var offset = $('#masthead').height();
            console.log(offset);

            if ($($.attr(this, 'href')).length > 0){
              event.preventDefault();
              $('html, body').animate({
                  scrollTop: $($.attr(this, 'href')).offset().top - offset
              }, 500);
            }
        });
    }

    function is_touch_device() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function(query) {
          return window.matchMedia(query).matches;
        }
      
        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
          return true;
        }
      
        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    }

    function handleNavForLargeTablet() {
        var screenWidth = updateViewportDimensions().width;
        if (screenWidth >= 1050 && is_touch_device()) {
            $body.addClass('large-tablet-device');
        }
    }

    // ----
    // public methods and variables
    // ----
    ns.init = function() {
        toggleNavMenu();
        smoothScroll();
        initLazyLoad();
        contentAccordion();
        addIeClassToBody();
        handleHeaderScroll();
        initCauseCardSlider();
        handleRipples();
        handleStories();
        handlePartnersSlider();
        handlePartnersBlock();
        handleCta3Block();
        handleSocialMediaClick();
        handleFaqs();
        handleMobileCardFlips();
        handleMenuArrows();
        handleDonationClick();
        // prepopulateForms();
        handleSmoothScroll();
        handleNavForLargeTablet();
    };

    ns.windowLoadInit = function() {
    };

}(braidStarter = braidStarter || {}, jQuery(window), jQuery));



jQuery(document).ready(function($) {
    braidStarter.init();
    $('[data-remodal-id=modal]').remodal({});
});

// jQuery(window).load(function() {
//     // braidStarter.windowLoadInit();
// });